import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { useQuery } from "@tanstack/react-query";

import { getBeefFeedTypes, getBeefFeedTypesAdmin } from "services";

import { getEnvironment, injectNames } from "utils";

import { DEFAULT_CACHE, GET_BEEF_FEED_TYPES } from "consts";

import { BeefFeedType } from "models";

export const useGetBeefFeedTypes = ({ enabled }: { enabled?: boolean } = {}) => {
  const { t } = useTranslation("beef", { useSuspense: false });
  const isAdmin = getEnvironment().admin;

  // Translate in select, not queryFn, so the cached data stays language-neutral and names follow language and namespace loads.
  const withTranslatedNames = useCallback((feedTypes: BeefFeedType[]) => injectNames(feedTypes, t, "feedTypes"), [t]);

  return useQuery({
    queryKey: [GET_BEEF_FEED_TYPES, { enabled }, isAdmin],
    queryFn: () => (isAdmin ? getBeefFeedTypesAdmin({ enabled }) : getBeefFeedTypes({ enabled })),
    select: withTranslatedNames,
    gcTime: DEFAULT_CACHE.gcTime,
    staleTime: DEFAULT_CACHE.staleTime,
  });
};
